// import React from "react";
import { useNavigate } from "react-router-dom";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
// import { Button } from "../ui/button";

export function Header() {
  const navigate = useNavigate();

  return (
    <header className="bg-zinc-900 py-4">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div
            className="cursor-pointer flex items-center"
            onClick={() => navigate("/")}
          >
            <img
              src="https://i.imgur.com/FjUZXhp.png"
              alt="Degen Coin Flip"
              className="h-12 mr-3"
            />
            <div className="text-white font-bold text-xl font-heading">
              <span className="text-white">DEGEN</span>
              <br />
              <span className="text-white">COIN FLIP</span>
            </div>
          </div>
          <div className="hidden md:block">
            <WalletMultiButton className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-md font-medium transition-colors duration-200 font-body" />
          </div>
        </div>
      </div>
    </header>
  );
}

// ... existing code ...
